import { FormFieldGroup, FormInput, FormLabel } from '$components'
import { Input } from './index'

export function CreateSizeCategoryFormContent() {
  return (
    <div className="flex flex-col gap-6 flex-grow">
      <FormFieldGroup>
        <FormLabel htmlFor={Input.Name}>Name</FormLabel>
        <FormInput
          name={Input.Name}
          placeholder="e.g. Small, Medium, Large..."
        />
      </FormFieldGroup>

      <div className="flex gap-4">
        <FormFieldGroup className="flex-1">
          <FormLabel htmlFor={Input.FromWeightLbs}>From (lbs)</FormLabel>
          <FormInput
            name={Input.FromWeightLbs}
            type="number"
            placeholder="0"
            min={0}
          />
        </FormFieldGroup>

        <FormFieldGroup className="flex-1">
          <FormLabel htmlFor={Input.ToWeightLbs}>To (lbs)</FormLabel>
          <FormInput
            name={Input.ToWeightLbs}
            type="number"
            placeholder="25"
            min={0}
          />
        </FormFieldGroup>
      </div>
    </div>
  )
}
